import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-600.css';
import './styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { bootstrapSession } from './services/auth/session';

// After a deploy, a tab opened earlier asks for page chunks that no longer exist. Reload once to
// pick up the new build; the flag stops a reload loop if the chunk is missing for another reason.
const RELOADED_KEY = 'bovid:chunk-reload';
window.addEventListener('vite:preloadError', (event) => {
  try {
    if (sessionStorage.getItem(RELOADED_KEY)) return;
    sessionStorage.setItem(RELOADED_KEY, '1');
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => {
  setTimeout(() => {
    try {
      sessionStorage.removeItem(RELOADED_KEY);
    } catch {
      // Storage blocked: nothing to clear.
    }
  }, 10_000);
});

// Restore the session (refresh token → access token) while React mounts.
void bootstrapSession();

const container = document.getElementById('root');
if (!container) throw new Error('index.html is missing the #root element');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
